/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingYouTranscript = [
  { type: 'heading', level: 2, text: 'Transcript' },
  { type: 'paragraph', text: '09:15 — You: Quick round on what shipped this week.' },
  { type: 'paragraph', text: '09:18 — Jordan: Notes rail polish is live, including search and new note.' },
  { type: 'paragraph', text: '09:22 — Sam: Working on inbox briefing layout wireframes.' },
  { type: 'paragraph', text: '09:31 — Alex: Pilot customers want longer transcript previews in the list.' },
  { type: 'paragraph', text: '09:40 — You: Let us lock design review for Thursday and share recap in Slack.' },
]
